import { SuppliersPageHeaderLoadingSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageHeaderLoadingSkeleton";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  BrandTilesLoadingSkeletonGrid,
  FilterPillsLoadingList,
} from "../__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandResults/__internal__/helpers";

export const SuppliersPageLoadingSkeleton: React.FC = () => {
  return (
    <div
      data-test-id="suppliers-page-loading-skeleton"
      style={{
        overflow: "hidden",
      }}
    >
      <SuppliersPageHeaderLoadingSkeleton />
      <FilterPillsLoadingList />
      <Spacer height="3x" />
      <BrandTilesLoadingSkeletonGrid />
    </div>
  );
};
